import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {
  Heading,
  PrimaryText
} from "components";

const defaultProps = {
  isCollectionPage: false,
  isInterview: false,
  isHome: false
};

const propTypes = {
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  isHome: PropTypes.bool,
  isInterview: PropTypes.bool,
  title: PropTypes.string.isRequired
};

const Banner = ({
  imageUrl,
  isInterview,
  isHome,
  title,
  description
}) => {
  return (
    <Container
      className="banner"
      imageUrl={imageUrl}
    >
      <h1
        className={`banner-text ${isHome ? "home-banner-text" : null}`}
      >
        {isInterview ? `"${title}"` : title}
      </h1>
      <h2 className="banner-sub-text">
        {description}
      </h2>
    </Container>
  );
};

const Container = styled.div`
  background-image: linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.65)), url(${props => props.imageUrl});
  background-position : 50% 50%;
  background-size: cover;
  display:-webkit-box;
  display:-ms-flexbox;
  display:-webkit-flex;
  display:flex;  /* add webkit properties for flex */
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
      -ms-flex-direction:column;
          -webkit-flex-direction:column;
          flex-direction:column;
  height:25.25em;
  -webkit-box-pack:center;
      -ms-flex-pack:center;
          -webkit-justify-content:center;
          justify-content:center;
  text-align:center;
  width:100%;
`;

Banner.defaultProps = defaultProps;
Banner.propTypes = propTypes;

export default Banner;


